import { produce } from 'immer';

import { UpdateInternalBannerImageByGallery } from '../../../actions/imageEditor/internal/updateInternalBannerImageByGallery';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageOrCreativeUploadingMode } from '../../../typings/banners';
import { ImageEditorsState } from '../../../typings/state';

export function updateInternalBannerImageByGallery(
    state: ImageEditorsState,
    action: UpdateInternalBannerImageByGallery
): ImageEditorsState {
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        const { images } = draft[id].imageGallery;

        let imageData;

        if (images) {
            imageData = images.find(item => item.hash === action.imagesHash[0]);
        }

        if (imageData) {
            draft[id].imageGallery.isImageGalleryOpen = false;
            draft[id].imageGallery.selectedImageHashFromGallery = [];
            draft[id].imageGallery.errors = undefined;

            draft[id].image.imageUrl = imageData.url;
            draft[id].image.uploadProgress = 0;
            draft[id].image.mode = ImageOrCreativeUploadingMode.UPLOADED;
            draft[id].image.isUploadByLink = false;
            draft[id].image.displayName = imageData.name;
            draft[id].image.errors = undefined;
            draft[id].image.fixedSize = {
                width: imageData.width,
                height: imageData.height
            };
            draft[id].image.data = {
                ...imageData,
                type: action.bannerType
            };
        }
    });
}
